import React from "react";
import Button from "components/button/Button";
import { SCROLLER_RECOMMENDED } from "./validator";

const typeLabel = type => {
  switch (type) {
    case "IMAGE":
      return "Image";
    case "TEXT":
      return "Text";
    case "IMAGE_TEXT":
      return "Image + Text";
    case "MIXED":
      return "Mixed";
    default:
      return type || "—";
  }
};

const ViewModal = ({ data, onEdit }) => {
  const slides = data?.advertisementResDTOSet
    ? [...data.advertisementResDTOSet].sort(
        (a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0)
      )
    : [];

  return (
    <div>
      <div className="form-group">
        <label className="fs-16 medium-text">Email&nbsp;:&nbsp;</label>
        {data?.email}
      </div>
      <div className="form-group">
        <label className="fs-16 medium-text">Device type&nbsp;:&nbsp;</label>
        {typeLabel(data?.fileType)}
      </div>
      <div className="form-group">
        <label className="fs-16 medium-text">Slides&nbsp;:&nbsp;</label>
        {slides.length}
      </div>
      <div
        className="mb-3 p-2 fs-13"
        style={{ background: "#f1f3ee", borderRadius: 6 }}
      >
        Recommended scroller image size: {SCROLLER_RECOMMENDED.width} ×{" "}
        {SCROLLER_RECOMMENDED.height} px
      </div>

      {slides.map((slide, i) => (
        <div
          key={slide.advertisementId || i}
          className="mb-4 p-3"
          style={{ border: "1px solid #e8ebe3", borderRadius: 8 }}
        >
          <div className="fs-15 demi-bold-text mb-2">
            Slide {i + 1} — {typeLabel(slide.fileType)}
          </div>

          {slide.fileType === "TEXT" && (
            <div className="fs-14">{slide.advertisement || "—"}</div>
          )}

          {(slide.fileType === "IMAGE" ||
            slide.fileType === "IMAGE_TEXT" ||
            (slide.advertisement &&
              slide.advertisement.startsWith("http"))) && (
            <>
              {slide.advertisement && (
                <img
                  className="view-image mb-2"
                  src={slide.advertisement}
                  alt={`Slide ${i + 1}`}
                  style={{
                    maxWidth: "100%",
                    width: Math.min(slide.imageWidth || 320, 480),
                    height: "auto",
                    borderRadius: 6,
                    border: "1px solid #e8ebe3"
                  }}
                />
              )}
              {(slide.imageWidth || slide.imageHeight) && (
                <div className="fs-13 text-muted mb-1">
                  Size:{" "}
                  <strong>
                    {slide.imageWidth || "—"} × {slide.imageHeight || "—"}
                  </strong>{" "}
                  px
                </div>
              )}
              {slide.fileType === "IMAGE_TEXT" && (
                <div
                  className="fs-14 p-2 text-center"
                  style={{
                    background: "rgba(15,23,42,0.8)",
                    color: "#fff",
                    borderRadius: 4,
                    maxWidth: 480
                  }}
                >
                  {slide.overlayText || "—"}
                </div>
              )}
            </>
          )}
        </div>
      ))}

      {onEdit && data?.deviceTokenId && (
        <div className="text-center pt-3">
          <Button className="c-btn c-success" onClick={() => onEdit(data)}>
            <i className="fas fa-edit mr-6" /> Edit scroller
          </Button>
        </div>
      )}
    </div>
  );
};

export default ViewModal;
